/**
 * Standardized page names for Hub analytics tracking
 *
 * All names use 'hub_' prefix for Mixpanel namespace clarity.
 * These are hardcoded English identifiers - never translated.
 * Dynamic routes are aggregated (e.g., /overview/123 and /overview/456
 * both map to hub_program_dashboard).
 */
export enum HubPageName {
  // Authentication & Public Pages
  LOGIN = 'hub_login',
  REGISTER = 'hub_register',
  REGISTER_CONTEST = 'hub_register_contest',
  FORGOT_PASSWORD = 'hub_forgot_password',
  RESET_PASSWORD = 'hub_reset_password',
  CONFIRM_EMAIL = 'hub_confirm_email',
  LOGOUT = 'hub_logout',

  // Main Navigation Pages
  OVERVIEW = 'hub_overview',
  PROGRAM_DASHBOARD = 'hub_program_dashboard',
  ORDERS = 'hub_orders',
  PROFILE = 'hub_profile',
  PROFILE_EDIT = 'hub_profile_edit',
  PROFILE_VERIFICATION = 'hub_profile_verification',

  // Contest Pages
  CONTESTS = 'hub_contests',
  CONTEST_DETAILS = 'hub_contest_details',
  CONTEST_DASHBOARD = 'hub_contest_dashboard',

  // Purchases/Orders Pages
  PURCHASES = 'hub_purchases',
  PURCHASES_ORDERS = 'hub_purchases_orders',
  PURCHASES_COUPONS = 'hub_purchases_coupons',
  PURCHASES_WITHDRAWALS = 'hub_purchases_withdrawals',

  // Affiliate Pages
  AFFILIATE = 'hub_affiliate',
  AFFILIATE_WELCOME = 'hub_affiliate_welcome',
  AFFILIATE_KIT = 'hub_affiliate_kit',

  // Content Pages
  ACHIEVEMENTS = 'hub_achievements',
  PLAYBOOK = 'hub_playbook',
  PLAYBOOK_DETAIL = 'hub_playbook_detail',
  TRADE_TALK = 'hub_trade_talk',
  TRADE_TALK_ARTICLE = 'hub_trade_talk_article',
  CHARTS = 'hub_charts',

  // Purchase Flow Pages
  NEW_ACCOUNT = 'hub_new_account',
  NEW_ADDON = 'hub_new_addon',
  PURCHASE = 'hub_purchase',
  AFTER_PURCHASE = 'hub_after_purchase',
  PAYSAFE_CHECKOUT = 'hub_paysafe_checkout',
  QUICK_PURCHASE = 'hub_quick_purchase',

  // Utility Pages
  WELCOME = 'hub_welcome',
  PARTNERS = 'hub_partners',
  POSITION = 'hub_position',
  PRIVACY_OPT_OUT = 'hub_privacy_opt_out',
  BLACKLISTED = 'hub_blacklisted',

  // Static/Iframe Pages
  AUTOCHARTIST = 'hub_autochartist',
  ASSETS_SPECIFICATIONS = 'hub_assets_specifications',
  HUB_DOWNLOADS = 'hub_downloads',
  HUB_VOD = 'hub_vod',
  TRADING_PLAN = 'hub_trading_plan',

  // Error/Fallback Pages
  NOT_FOUND = 'hub_not_found',
  UNKNOWN = 'hub_unknown',
}
